module.exports = __webpack_public_path__ + "static/logoSerratek-98c6f89b69e2f5b289c18c2050103b48.png";